module.exports = __webpack_public_path__ + "img/151.b81b50ff.png";